import React from 'react';
import { TimelineTrackPoint } from './TimelineTrack';

/**
 * Timeline slot content.
 *
 * Displays a set of timestamped markers in the track
 */
export function TimelineMarkers(props: {
  items: { icon?: React.ReactNode; text?: string; time: number }[];
}): React.ReactElement {
  const { items } = props;
  return (
    <div className="odin-relative odin-min-h-[32px] odin-w-full">
      {items.map(({ icon, text, time }) => (
        <TimelineTrackPoint key={`marker-item-${time}`} time={time}>
          <div className="odin-flex odin-gap-2 odin-items-center odin-justify-start">
            {icon}
            {!!text && (
              <strong className="odin-text-xs odin-font-bold">{text}</strong>
            )}
          </div>
        </TimelineTrackPoint>
      ))}
    </div>
  );
}
